angular.module('unergie.main')
.filter('invoiceStatus', () => {
    const filter = function (value) {
        switch (value) {
            case 0: return 'INITIAL'
            case 1: return 'HOLD'
            case 11: return 'VALUATED'
            case 12: return 'VALUATED_TO_CHECK'
            case 10: return 'PROCESSING'
            case 20: return 'CONSUMPTION_WARNING'
            case 21: return 'CONSUMPTION_ERROR'
            case 30: return 'EXTERNAL PROCESSING'
            case 31: return 'TIMETABLE OK'
            case 40: return 'PREPARED'
            case 41: return 'SIMULATING'
            case 42: return 'RUNNING'
            case 49: return 'HOLD PREPARED'
            case 500: return 'SIMU TT OK'
            case 501: return 'SIMU OK'
            case 502: return 'SIMU TO CHECK'
            case 50: return 'DONE'
            case 54: return 'PARTIAL'
            case 55: return 'INVOICED'
            case 59: return 'HOLD DONE'
            case 70: return 'CANCELLED'
            case 71: return 'CANCELED_NO_CHANGE'
            case 75: return 'REVERTED'
            case 90: return 'ERROR'
            case 91: return 'ERROR VALO'
            case 92: return 'ERROR PREP'
            case 93: return 'ERROR PDF'
            case 94: return 'ERROR SIMU TT'
            case 95: return 'ERROR TT'
            case 96: return 'ERROR SENDING'
            case 99: return 'ERROR SIMU'
            default: return value
        }
    }

    return filter
})
